import React from 'react';
import ImageLink from '../ImageLink';
import { applyCheckboxIcon, getBrandColor } from '../../../pages/createEvent/page/SelectMesaType/components/svgIcons';

class CheckBox extends React.Component {


  componentDidMount() {
    const brandColor = getBrandColor();
    applyCheckboxIcon('.checkbox label', brandColor, '--check-icon');
  }

  componentDidUpdate() {
    const brandColor = getBrandColor();
    applyCheckboxIcon('.checkbox label', brandColor, '--check-icon');
  }

  getselectedCheckBoxValue = (event, data, scope) => {
    const selectedData = Object.assign({}, data);
    selectedData.checked = event.target.checked;
    if (scope.props.getSelectedValue) {
      scope.props.getSelectedValue(selectedData);
    }
  }
  isChecked() {
    return this.chk.checked;
  }
  componentWillReceiveProps(props) {
    if (this.props.changeOnPropsChange) {
      this.setChecked(props.defaultChecked);
    }
  }
  setChecked(chk) {
    this.chk.checked = chk;
  }
  setDisabled(chk) {
    this.chk.disabled = chk;
  }
  render() {
    const props = this.props;
    const mobileView = props.className;
    const styleShow = props.ShowStyle;
    const view = (
      () => {
        if (mobileView) {
          return 'checkbox';
        } else if (styleShow === 'horizontal') {
          return 'checkboxH';
        } else if (props.customCss && !props.isSuspended) {
          return 'checkbox checkboxCustom';
        } else if (props.disabled && props.isSuspended) {
          return 'checkbox disabledCheckbox'
        }
        return 'checkbox';
      }
    )();
    // const checkboxCode = (
    //   );
    return (
      <div className={view}>
        <input
          className={props.checkClass}
          type="checkbox"
          // className={props.className}
          id={(props.id || props.htmlId) ? (props.id || props.htmlId) : null}
          value={props.value}
          name={props.name}
          disabled={(props.disabled) ? 'disabled' : null}
          checked={props.checked}
          defaultChecked={props.defaultChecked}
          onChange={event => this.getselectedCheckBoxValue(event, this.props, this)}
          ref={chk => this.chk = chk}
          data-type={(props.datatype) ? props.datatype : null}
        />
        <label
          htmlFor={(props.id || props.htmlId) ? (props.id || props.htmlId) : null}
          ref={lbl => this.label = lbl}
          className='wap_label'
        >
          {props.displayName}
          {props.image ? <ImageLink imgLinkData={props.image} /> : null}
        </label>
        {this.props.children ? this.props.children : null}
      </div>
    );
  }
}
export default CheckBox;
